import { createContext, useContext } from 'react';

// Carries the current Suite context (suiteId) so tile queries, drills and
// filter suggestions are scoped (organiser) and pre-filled to that suite.
// null = no suite (admin previewing a dashboard directly → unscoped).
// entityId/dashboardId let a tile act on itself (e.g. create a segment).
//
// It also carries per-tile lock data: `tileLocks` ({ tileId: { filterName:
// value } }) is applied to a tile's query; `lockFilters` is the dashboard's
// filters (so an admin can pick which to lock on a tile); `canLockTiles` gates
// the admin affordance; `onSaveTileLock(tileId, map)` persists a tile's locks.
// `combinedLocks` are cross-field OR locks ([{ op, fields, value }]) that can't
// live in the per-field value map — a tile forwards the ones that apply to it to
// the server, which turns them into a Looker filter_expression.
// `suiteName` rides along purely for wording (e.g. "watching this for Rocking the
// Daisies" in the tile's alert sheet) — never for scoping, which is suiteId's job.
const ScopeContext = createContext({ suiteId: null, suiteName: '', dashboardContext: '', entityId: null, dashboardId: null, refreshKey: 0, softKey: 0, tileLocks: {}, lockFilters: [], combinedLocks: [], canLockTiles: false, onSaveTileLock: null });

export function ScopeProvider({ suiteId, suiteName = '', dashboardContext = '', entityId = null, dashboardId = null, refreshKey = 0, softKey = 0, tileLocks = {}, lockFilters = [], combinedLocks = [], canLockTiles = false, onSaveTileLock = null, children }) {
  return (
    <ScopeContext.Provider value={{ suiteId: suiteId || null, suiteName: suiteName || '', dashboardContext: dashboardContext || '', entityId: entityId || null, dashboardId: dashboardId || null, refreshKey, softKey, tileLocks: tileLocks || {}, lockFilters: lockFilters || [], combinedLocks: combinedLocks || [], canLockTiles: !!canLockTiles, onSaveTileLock }}>
      {children}
    </ScopeContext.Provider>
  );
}

export function useScope() {
  return useContext(ScopeContext);
}
